import { Link } from "react-router-dom";

export default function HomeTwoService(){
    return(
        <>
            <section id="services" className="services-area pt-120 pb-120 pt-md-60 pt-xs-60 pb-md-60 pb-xs-100">
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-xl-6">
						<div className="services-title2 text-center mb-45">
							<h2 className="style-text">Service</h2>
							<h6 className="semi-title semi-title2">Service</h6>
							<h2 className="sect-title text-heding2">What we transform in real life</h2>
						</div>
					</div>
				</div>
			</div>
			<div className="container">
				<div className="row">
					<div className="col-lg-4 col-md-6">
						<div className="single-services2 mb-30">
							<div className="d-sm-flex align-items-center">
								<div className="s-icon">
									<img src="assets/img/icon/s-2a.png" alt="Services icon" />
								</div>
								<h4 className="sub-title">Website Design & Development</h4>
							</div>
							<p>Voice and Data Systems are crucial to the
								success or failure of most businesses.</p>
							<Link to="/services-details" className="read-more">Read More <i
									className="fal fa-long-arrow-right"></i></Link>
						</div>
					</div>
					<div className="col-lg-4 col-md-6">
						<div className="single-services2 mb-30">
							<div className="d-sm-flex align-items-center">
								<div className="s-icon">
									<img src="assets/img/icon/s-2b.png" alt="Services icon" />
								</div>
								<h4 className="sub-title">Search Engine Optimization</h4>
							</div>
							<p>Voice and Data Systems are crucial to the
								success or failure of most businesses.</p>
							<Link to="/services-details" className="read-more">Read More <i
									className="fal fa-long-arrow-right"></i></Link>
						</div>
					</div>
					<div className="col-lg-4 col-md-6">
						<div className="single-services2 mb-30">
							<div className="d-sm-flex align-items-center">
								<div className="s-icon">
									<img src="assets/img/icon/s-2c.png" alt="Services icon" />
								</div>
								<h4 className="sub-title">Product Design & AI Base</h4>
							</div>
							<p>Voice and Data Systems are crucial to the
								success or failure of most businesses.</p>
							<Link to="/services-details" className="read-more">Read More <i
									className="fal fa-long-arrow-right"></i></Link>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-12 text-center">
						<h5 className="link-text fs-20 text-heding2 mb-30">5000+ worldwide basecamp & solution maneger. <Link
								className="get-btn" to="/contact">Get In Touch</Link></h5>
					</div>
				</div>
			</div>
		</section>
        </>
    )
}